import get from 'lodash.get';
import { PAGE_SIZE_OPTIONS } from '../constants/sbConstants';
import { sbAdMap } from '../constants/sbAdMap';

/* Constants */
import {
    QP_PAGE_SIZE_VALUE_DEFAULT,
    QP_PAGE_SIZE_VALUE_MAX,
} from '../constants/queryParamConstants';

const TILE_AD_KEY = 'productTile';
const sbAdConfigKeyList = Object.keys(sbAdMap);

export const adLimitMap = PAGE_SIZE_OPTIONS.reduce((map, option) => {
    map[option.size] = option.adLimit;
    return map;
}, {});

export const getAdData = (uriRef, adKey) => {
    const segments = uriRef.split('?')[0].split('/');
    const key = segments.find(segment => sbAdConfigKeyList.includes(segment)) || 'default';
    return get(sbAdMap[key], adKey);
};

function getAdCountForPage({ pageSize = QP_PAGE_SIZE_VALUE_DEFAULT, uriRef }) {
    const numberOfTotalTileAds = (getAdData(uriRef, TILE_AD_KEY) || []).length;

    /**
     * if we cant find a limit in our limit map just use the number of ads from the ad map
     * adLimitMap is keyed by page size selected (120, 60) not number of tiles shown (ie 116, 58)
     */
    const adLimit = adLimitMap[pageSize] || numberOfTotalTileAds;
    const numberOfTileAds = numberOfTotalTileAds <= adLimit ? numberOfTotalTileAds : adLimit;

    return numberOfTileAds;
}

export function getNumberOfTiles({
    path,
    pageSize = QP_PAGE_SIZE_VALUE_DEFAULT,
    isSbAdsEnabled = true,
}) {
    if (isSbAdsEnabled) {
        return pageSize - getAdCountForPage({ uriRef: path, pageSize });
    }
    return pageSize;
}

// Stole this logic from .com
// https://github.com/1stdibs/1stdibs.com/blob/master/dibs/assets/js/finding/general/placementAds.js#L87
const getProductTileAdIndex = (adIndex, pageCol = 3, adRow = 8) => {
    let slotIndex;
    // (num of columns) * (row to appear in) offset by one
    const initialOffset = adIndex + 1;
    const numCols = pageCol * adRow * initialOffset;
    slotIndex = numCols - 1;

    // ad position offset. Moves the ad from left to right of row
    const offset = (adIndex + 1) % 2 === 0 ? pageCol - 2 : 0;
    slotIndex -= offset;

    return slotIndex;
};

const shouldGetProductTileAds = ({ numOfTiles }) => {
    if (numOfTiles === QP_PAGE_SIZE_VALUE_DEFAULT || numOfTiles === QP_PAGE_SIZE_VALUE_MAX) {
        return false;
    }

    return true;
};

export const getPageSizeOfTiles = ({ uriRef, numOfTiles }) => {
    // tilesToPageSizeMapForPage is indexed by numb of tiles (pageSize - adCount) to pageSize
    // e.g.{ 58: 60, 116: 120 } or { 58: 60, 118: 120 } (for art only because it has 2 ads max) or { 60: 60, 120: 120 }
    const tilesToPageSizeMapForPage = PAGE_SIZE_OPTIONS.reduce((map, option) => {
        const adCount = getAdCountForPage({ uriRef, pageSize: option.size });
        map[option.size - adCount] = option.size;
        return map;
    }, {});

    return tilesToPageSizeMapForPage[numOfTiles];
};

export const getProductTileAdMap = ({ uriRef, pageCol, adRow, pageSize: numOfTiles }) => {
    if (!numOfTiles || !shouldGetProductTileAds({ numOfTiles })) {
        return {};
    }

    const productTileAdData = getAdData(uriRef, TILE_AD_KEY) || [];
    const adLimit = getAdCountForPage({
        uriRef,
        pageSize: getPageSizeOfTiles({ uriRef, numOfTiles }), // we need to map numOfTiles back to original pageSize to get correct adLimit
    });

    return (
        productTileAdData
            // limit by number of ads per page size
            .slice(0, adLimit)
            // get index
            .reduce((map, data, i) => {
                map[getProductTileAdIndex(i, pageCol, adRow)] = data;

                return map;
            }, {})
    );
};
